/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating';
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions(value) {
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Screenshots': json['Screenshots'] == null ? undefined : json['Screenshots'],
        'InstallCount': json['InstallCount'] == null ? undefined : json['InstallCount'],
        'Rating': json['Rating'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSON(json['Rating']),
        'Genre': json['Genre'] == null ? undefined : json['Genre'],
        'LastUpdate': json['LastUpdate'] == null ? undefined : (new Date(json['LastUpdate'])),
        'VideoUrl': json['VideoUrl'] == null ? undefined : json['VideoUrl'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Screenshots': value['Screenshots'],
        'InstallCount': value['InstallCount'],
        'Rating': FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSON(value['Rating']),
        'Genre': value['Genre'],
        'LastUpdate': value['LastUpdate'] == null ? undefined : (value['LastUpdate'].toISOString()),
        'VideoUrl': value['VideoUrl'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions.js.map